import useWishlist from 'hooks/account/useWishlist';
import useWishlistData from 'hooks/account/useWishlistData';
import styled, { Box, th } from '@xstyled/styled-components';
import Button from '@/UI/Button';
import { Heart } from '@/UI/Icons';
import { useTranslation } from 'next-i18next';


const WishlistButton = styled(Button)`
  display: inline-flex;

  &:hover {
    svg g {
      fill: ${({ favorited }) => (favorited ? 'none' : th.color('pink-100'))};
    }
  } 
`;

export default function Favorite({ product }) {
  const { t } = useTranslation();

  const { itemId } = useWishlistData(product);

  const { addToWishlist, removeFromWishlist } = useWishlist(product);

  const handleFavorite = () => {
    itemId ? removeFromWishlist() : addToWishlist();
  };

  return (
    <WishlistButton spaceX={8} onClick={handleFavorite} favorited={itemId}>
      <span role="img" aria-label="Heart icon">
        <Heart fill={itemId ? '#fe93bf' : 'none'} />
      </span>
      <Box as="span" fontSize="0.875rem" color="gray-200">
        {itemId ? t('wishlist.remove') : t('wishlist.add')}
      </Box>
    </WishlistButton>
  );
}
